import { Controller } from '@hotwired/stimulus';
import { Helpers } from '../helpers';
import * as bootstrap from 'bootstrap';

export default class InvestFormController extends Controller {
  static targets = [
    'subscriptionAmount',
    'feesAmount',
    'containerFieldsErrors',
    'fieldsErrors',
    'subscriptionAmountDivs',
    'feesAmountDivs',
    'totalAmountDivs',
    'modalTotal',
    'submitButton',
    'insufficientBalance',
    'subscribeModal',
    'provisionalBalance',
  ];

  static values = {
    insufficientBalanceMessage: String,
    noAmountMessage: String,
    projectId: String,
    profileBalance: Number,
    max_invest_recommendation: Number,
    user_may_have_warning: Boolean,
    rangeOverflowMessage: String,
  };

  connect() {
    this.computeFeesAndTotal();
  }

  // Compute fees and total through backend
  computeFeesAndTotal() {
    const amount = this.subscriptionAmountTarget.value;
    let controller = this;
    const profileBalance = parseFloat(this.profileBalanceValue);

    // Check if the amount is valid
    controller.checkAmountValidity(amount);

    // Display amount
    controller.modalTotalTarget.innerHTML =
      Helpers.numberToCurrency(amount, 2);

    controller.provisionalBalanceTarget.innerHTML =
      Helpers.numberToCurrency(profileBalance - amount, 2);

    this.updateButtonState(amount, profileBalance);
  }

  checkAmountValidity(amount) {
    if (this.hasInsufficientBalanceTarget) {
      this.insufficientBalanceTarget.classList.add('d-none');
    }

    const profileBalance = parseFloat(this.profileBalanceValue);
    const checkValidity = !this.subscriptionAmountTarget.checkValidity();
    const emptyAmount = amount === '';

    const hasError = checkValidity || emptyAmount || amount > profileBalance;

    this.containerFieldsErrorsTarget.classList.toggle('d-none', !hasError);

    switch (true) {
      case checkValidity:
        this.fieldsErrorsTarget.innerHTML = this.rangeOverflowMessageValue;
        return this.triggerError();
      case emptyAmount:
        this.fieldsErrorsTarget.innerHTML = this.noAmountMessageValue;
        return this.triggerError();
      case amount > profileBalance:
        this.fieldsErrorsTarget.innerHTML = this.insufficientBalanceMessageValue;
        return this.triggerError();
      default:
        this.submitButtonTarget.classList.remove('disabled');
        this.fieldsErrorsTarget.innerHTML = '';
        this.subscriptionAmountTarget.classList.remove('is-invalid');
        return true;
    }
  }

  updateAmounts(container, amount) {
    const finalAmount =
      amount === 0 || isNaN(amount)
        ? 'CHF -,--'
        : Helpers.numberToCurrency(amount, 2);

    container.forEach((element) => {
      element.innerHTML = finalAmount;
    });
  }

  triggerError() {
    this.submitButtonTarget.classList.add('disabled');
    this.subscriptionAmountTarget.classList.add('is-invalid');
    return false;
  }

  validateAndShowSubscriptionModal() {
    const amount = this.subscriptionAmountTarget.value;
    const maxInvestRecommendation = this.maxInvestRecommendationValue;

    if (!this.checkAmountValidity(amount)) return;

    this.showModal(this.subscribeModalTarget);
  }

  preventAutoSubmit(event) {
    event.preventDefault();
    this.validateAndShowSubscriptionModal();
  }

  showModal(modalTarget) {
    const modal = new bootstrap.Modal(modalTarget);
    modal.show();
  }

  updateButtonState(amount, profileBalance) {
    const isInvalid = !amount || amount <= 0 || amount > profileBalance;
    this.submitButtonTarget.disabled = isInvalid;
  }
}
